<template>
  <div class="picker-change">
    <div class="m-b30" v-for="(item, i) in list" :key="i" style="clear: both;">
      <PickerSectionTitle :item="item" :isChangePage="true"></PickerSectionTitle>
      <el-table
        :data="setTabelData(item && item.orderItems)"
        style="width: 100%;"
        show-summary
        class="c-3 f-13"
        :span-method="getSpanMethods(item.orderItems)"
      >
        <el-table-column prop="name" label="商品" align="center">
          <template slot-scope="scope">
            <div class="">{{ scope.row.name }}</div>
            <div v-if="scope.row.supplierName" class="f-12 c-9">
              {{ scope.row.supplierName }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="商品属性" align="center" width="150">
          <template slot-scope="scope">
            <ul>
              <li>{{ scope.row.desc }}</li>
              <li>计量方式：{{ scope.row.type }}</li>
              <li>{{ scope.row.perWeight }}</li>
              <li>计价单位：{{ scope.row.weightUnitValue | exUnitToBaseUnit }}</li>
            </ul>
          </template>
        </el-table-column>
        <el-table-column prop="perPrice" label="单价" align="center" width="150">
          <template slot-scope="scope">
            <span class="c-red"
              >{{ scope.row.perPrice }} / {{ scope.row.weightUnitValue | exUnitToBaseUnit }}</span
            >
            <zg-info
              v-if="
                scope.row.logisticsPrice ||
                  scope.row.processFee ||
                  scope.row.storageFee ||
                  scope.row.commissionFee ||
                  scope.row.promiseInterestSubsidyFee ||
                  scope.row.settleAdjustFee
              "
            >
              <div slot="content">
                <div v-if="scope.row.logisticsPrice">
                  胖猫物流费：{{ scope.row.logisticsPrice }}
                </div>
                <div v-if="scope.row.processFee">加工费：{{ scope.row.processFee }}</div>
                <div v-if="scope.row.storageFee">仓储费：{{ scope.row.storageFee }}</div>
                <div v-if="scope.row.commissionFee">委托物流费：{{ scope.row.commissionFee }}</div>
                <div v-if="scope.row.promiseInterestSubsidyFee">
                  承兑贴息费：{{ scope.row.promiseInterestSubsidyFee }}
                </div>
                <div v-if="scope.row.settleAdjustFee">
                  结算调差费：{{ scope.row.settleAdjustFee }}
                </div>
              </div>
            </zg-info>
          </template>
        </el-table-column>
        <el-table-column
          prop="preNum"
          label="预提数量"
          align="center"
          width="100"
        ></el-table-column>
        <el-table-column
          prop="preWeight"
          label="预提重量(吨)"
          align="center"
          width="120"
        ></el-table-column>
        <template v-if="!isNotify">
          <el-table-column prop="realNum" label="实提数量" align="center" width="100">
            <template slot-scope="scope">
              <el-input
                :disabled="PickerStatusStr[item.status] !== '待发货'"
                @input="inputRealNum(scope, item)"
                class="text-center"
                v-model="scope.row.realNum"
                type="text"
                maxLength="6"
              ></el-input>
              <div class="tip c-warning">{{ checkRealNumTip(scope, item) }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="realWeight" label="实提重量(吨)" align="center" width="200">
            <template slot-scope="scope">
              <el-input
                :disabled="
                  PickerStatusStr[item.status] !== '待发货' && Number(scope.row.realNum) === 0
                "
                @input="inputRealWeight(scope, item)"
                class="text-center"
                v-model="scope.row.realWeight"
                type="text"
                maxLength="16"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="realPrice" label="实提金额(元)" align="center" width="120">
            <template slot-scope="scope">
              {{ getRealPrice(scope, item) }}
            </template>
          </el-table-column>
        </template>
        <template v-else>
          <el-table-column label="提货函状态" align="center" width="150">
            <span v-show="item.signStatus < 4" class="c-red">
              未签署
            </span>
            <span v-show="item.signStatus === 4" class="c-success">
              {{ item.signType !== 'transfer_apply' ? '线下签署' : '已签署' }}
            </span>
          </el-table-column>
          <el-table-column label="操作" align="center" width="150">
            <template>
              <!-- 如果状态为0，可以在线签署 -->
              <!-- v-if="item.signStatus === 0" -->
              <el-link v-if="item.signStatus < 4" type="primary" key="1" @click="goToSign(item)">
                在线签署提货函
              </el-link>
              <el-link
                v-if="item.signStatus === 4 && item.signType === 'transfer_apply'"
                type="primary"
                key="2"
                @click="toSignDetail(item)"
              >
                查看提货函
              </el-link>
              <!-- 如果状态是0或者是手动上传状态为4 -->
              <el-link
                v-if="!(item.signStatus === 4 && item.signType === 'transfer_apply')"
                type="primary"
                key="3"
                @click="showUploadDialog(item)"
              >
                {{ item.signStatus === 4 ? '查看/编辑提货函' : '手动上传提货函' }}
              </el-link>
            </template>
          </el-table-column>
          <el-table-column label="实提数量/重量(吨)" align="center" width="200">
            <template>
              0 / 0
            </template>
          </el-table-column>
        </template>
      </el-table>
      <el-button
        size="medium"
        type="primary"
        style="float: right; margin: 25px 0;"
        @click="showPickerDialog(item)"
      >
        {{ item.status >= 3 ? '查看发货凭证' : '上传发货凭证' }}
      </el-button>
    </div>
    <div v-if="list.length === 1" class="text-right m-t30" style="clear: both;">
      <template v-if="isNotify">
        <span class="p-r20 c-9 f-12"
          >若您是货主，请在线签署提货函；若您不是货主，请线下签署提货函后手动上传。完成后，再通知仓库发货。</span
        >
        <el-button size="medium" type="primary" @click="onNotify">通知仓库发货</el-button>
      </template>
      <template v-else>
        <el-button size="medium" class="m-r20" type="primary" @click="saveReal">{{
          list[0].statusCode === 'WAITING_CONFIRM' ? '暂时保存' : '确认修改'
        }}</el-button>
        <el-button
          size="medium"
          v-if="list[0].statusCode === 'WAITING_CONFIRM'"
          type="primary"
          @click="openMsgBox"
          >确认发货</el-button
        >
      </template>
      <el-button size="medium" @click="goBackPage">取 消</el-button>
    </div>
    <div v-else-if="list.length > 1" class="text-right m-t30" style="clear: both;">
      <!-- <el-button size="medium" class="m-r20" type="primary" @click="saveReal">暂时保存</el-button> -->
      <el-button size="medium" type="primary" @click="openMsgBox">批量发货</el-button>
      <el-button size="medium" @click="goBackPage">取 消</el-button>
    </div>
    <real-name-verify
      :visible.sync="isShowVerify"
      :showRange="showRange"
      @close="showRange = 0"
    ></real-name-verify>
    <picker-upload-dialog
      :contract-id="pickerInfo.contractId"
      :file-key="pickerInfo.signType === 'hand' ? pickerInfo.fileKey : ''"
      :contract-no="pickerInfo.contractNo"
      :contract-version="pickerInfo.contractVersion"
      :dispatch-order-no="pickerInfo.dispatchOrderNo"
      :extraParam="extraParam"
      :visible.sync="isShowUploadDialog"
      @reload="getData"
      is-show-progress
    ></picker-upload-dialog>
    <el-dialog
      title="未签署提货函"
      :visible="isShowUploadTip"
      append-to-body
      modal-append-to-body
      width="30%"
      @close="isShowUploadTip = false"
    >
      <div>
        请先签署提货函，再通知仓库发货。
      </div>
      <el-row slot="footer" class="text-c">
        <el-col :span="12">
          <el-button
            type="primary"
            @click="
              showUploadDialog(list[0])
              isShowUploadTip = false
            "
            >手工上传提货函</el-button
          >
        </el-col>
        <el-col :span="12">
          <el-button type="primary" @click="goToSign(list[0])">在线签署提货函</el-button>
        </el-col>
      </el-row>
    </el-dialog>
    <upload-picker-dialog
      ref="viewPickerDialog"
      @confirm="saveUploadFiles"
      :show-option="isShowOption"
    ></upload-picker-dialog>
  </div>
</template>

<script>
import PickerSectionTitle from './components/picker-section-title'
import { fixTDP } from '@/common/utils/my.js'
import { formatWeight, formatMoneyCent, formatPermil, exUnit } from '@/common/filters/index.js'
import { PickerTypeCode, PickerStatusStr } from './code'
import RealNameVerify from '@/components/sign/info-verify'
import PickerUploadDialog from './components/picker-upload-dialog'
import { makeImage } from '@/common/filters'
import { download } from '@/common/utils/download'
import UploadPickerDialog from './components/uploadPickerDialog'
import ZgInfo from '@/components/zg-info'

export default {
  name: 'PickerChange',
  components: {
    PickerSectionTitle,
    RealNameVerify,
    PickerUploadDialog,
    UploadPickerDialog,
    ZgInfo
  },
  data() {
    return {
      PickerStatusStr,
      list: [],
      tableList: [],
      total: {
        totalRealNum: 0,
        totalRealWeight: 0,
        totalRealPrice: 0
      },
      canPicker: true,
      pickerInfo: {},
      isShowUploadDialog: false,
      isShowVerify: false,
      isShowUploadTip: false,
      showRange: 0,
      isShowOption: false
    }
  },
  computed: {
    extraParam() {
      if (this.list && this.list[0]) {
        const { buyerOrgId, sellerOrgId, warehouseOrgId } = this.list[0]
        return {
          orgIds: [buyerOrgId, sellerOrgId, warehouseOrgId]
        }
      } else {
        return {}
      }
    },
    queryList() {
      return JSON.parse(decodeURIComponent(this.$route.query.list))
    },
    isNotify() {
      return this.$route.path === '/picker/notify'
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      // 获取已有的产品信息
      const { success, data } = await this.$get('lgcenter.commitDispatchOrderInfoForSeller', {
        commitDispatchOrderInfoForSeller: { itemCommitInfoList: this.queryList }
      })
      if (success && data[0].success) {
        data[0].data.forEach(item => {
          item.errorTip = ''
        })
        let list = data[0].data
        let [picker] = list
        if (this.isNotify && picker && picker.isOnline === 0) {
          this.$alert('当前仓库已下线，请直接填写实提', '提示', {
            confirmButtonText: '确定',
            callback: action => {
              this.$store.commit('tagsView/DEL_VISITED_VIEW', { path: this.$route.path })
              this.$router.replace({ name: 'picker-change', query: { ...this.$route.query } })
            }
          })
        } else {
          this.list = list
        }
      } else {
        this.$message.error(data[0].message || '获取数据失败')
        this.goBackPage()
      }
    },
    onNotify() {
      if (this.list[0].signStatus === 4) {
        this.openNotifyMsgBox()
      } else {
        this.isShowUploadTip = true
      }
    },
    showUploadDialog(picker) {
      if (!picker.contractNo) {
        return this.$message.error('合同尚未生成成功，请刷新后重试')
      }
      this.pickerInfo = picker
      this.isShowUploadDialog = true
    },
    // 如果是通知仓库发货，合并单元格
    getSpanMethods({ length }) {
      if (this.isNotify) {
        return ({ columnIndex, rowIndex }) => {
          if ([5, 6, 7].includes(columnIndex)) {
            if (rowIndex === 0) {
              return {
                rowspan: length,
                colspan: 1
              }
            } else {
              return {
                rowspan: 0,
                colspan: 0
              }
            }
          }
        }
      } else {
        return () => {}
      }
    },
    setTabelData(cells) {
      let tableList = []
      cells.forEach(cell => {
        let {
          productTitle,
          productSubTitle,
          bundleNo,
          productPrice,
          weightUnitValue,
          valuationWay,
          perProductWeight,
          preProductNum,
          preProductWeight,
          realProductNum,
          realProductWeight,
          supplierName,
          logisticsPrice,
          processFee,
          storageFee,
          commissionFee,
          promiseInterestSubsidyFee,
          settleAdjustFee
        } = cell
        let tableData = {
          weightUnitValue: weightUnitValue,
          supplierName,
          name: productTitle,
          desc:
            typeof bundleNo === 'undefined' || bundleNo === '' || bundleNo === null
              ? ''
              : `捆包号：${bundleNo}`,
          type: typeof valuationWay !== 'undefined' ? `${valuationWay}` : '',
          perWeight: `单件重：${formatWeight(perProductWeight)} 吨`,
          perPrice: `¥ ${productPrice}`,
          pre: `${preProductNum}${exUnit(weightUnitValue)} / ${formatWeight(preProductWeight)}吨`,
          real: `${realProductNum}${exUnit(weightUnitValue)} / ${formatWeight(
            realProductWeight
          )}吨`,
          preNum: preProductNum,
          preWeight: formatWeight(preProductWeight),
          realNum: realProductNum === 0 ? 0 : realProductNum,
          realWeight: formatWeight(realProductWeight) == 0 ? 0 : formatWeight(realProductWeight),
          logisticsPrice,
          processFee,
          storageFee,
          commissionFee,
          promiseInterestSubsidyFee,
          settleAdjustFee
        }
        // ~~~~~~~这里有疑问
        // 这里处理一下抄码情况, 列表展示的数据, 仅未实提过, 且为抄码或理计的商品, 设置初始值
        if ((valuationWay === '抄码' || valuationWay === '理计') && realProductNum !== 0) {
          // 表格展示的实提数据 = 格式化后的预提数据
          // tableData.realNum =  preProductNum
          // tableData.realWeight = formatWeight(preProductWeight)
        }
        tableList.push((cell.tableData = tableData))
      })
      return tableList
    },
    checkRealNumTip({ $index, row }, item) {
      if (PickerStatusStr[item.status] !== '待发货') return ''
      let ex = Number(row.realNum) - Number(row.preNum)
      let exTon = Number(row.realWeight) - Number(row.preWeight)
      if (row.weightUnitValue === 'TON' || row.weightUnitValue === 'KG') {
        if (Number(row.realNum) === 0 || Number(row.realWeight) === 0) {
          return '实提为0, 该商品将会返回待提列表'
        }
        if (row.type === '过磅') {
          if (exTon < 0) {
            return `剩余${Math.abs(exTon.toFixed(6))}吨未提，买家确认收货后可通过二次结算退款`
          } else if (exTon > 0) {
            return `${Math.abs(exTon.toFixed(6))}吨超发，买家确认收货后可通过二次结算补款`
          } else {
            return ''
          }
        } else {
          if (ex < 0) {
            return `剩余${Math.abs(
              ex
            )}件未提，未提的件数将返还至待发货商品，可重新申请提货；如不再提剩余件数，可在订单详情页-商品上点击【退货】`
          } else if (ex > 0) {
            return `不允许件数超发，需买家补单`
          } else {
            return ''
          }
        }
      } else {
        if (ex != 0) {
          return `实提数量应与预提数量相同`
        }
      }
    },
    inputRealNum({ $index, row }, item) {
      let reg = /(^[1-9]\d*$)|(^0)/ // 正整数且>0
      let match = row.realNum.match(reg)
      let realNum = ''
      if (match !== null) {
        realNum = match[0]
      }
      row.realNum = realNum
      // 修改数据源
      item.orderItems[$index].realProductNum = row.realNum
    },
    inputRealWeight({ $index, row }, item) {
      let reg = /(^[1-9]\d{0,7}\.\d{0,6})|(^[1-9]\d{0,7})|(^0\.\d{0,6})|(^0)/
      let match = row.realWeight.match(reg)
      let realWeight = ''
      if (match !== null) {
        realWeight = match[0]
      }
      row.realWeight = realWeight
      // 修改数据源
      item.orderItems[$index].realProductWeight = (row.realWeight * 10000).toString()
    },
    // 实时计算实提金额
    getRealPrice({ $index, row }, item) {
      row.realPrice =
        Number(row.perPrice.replace('¥', '')) *
        (row.weightUnitValue === 'TON' || row.weightUnitValue === 'KG'
          ? Number(row.realWeight) * (row.weightUnitValue === 'KG' ? 1000 : 1)
          : 1)
      if (row.weightUnitValue !== 'TON' && row.weightUnitValue !== 'KG') {
        row.realPrice = row.realPrice * Number(row.realNum)
      }
      row.realPrice = row.realPrice.toFixed(2)
      // 修改数据源
      item.orderItems[$index].realProductPrice = item.orderItems[$index].tableData.realPrice =
        row.realPrice
      return row.realPrice
    },
    resetTotalData() {
      this.total.totalRealNum = 0
      this.total.totalRealWeight = 0
      this.total.totalRealPrice = 0
    },
    // 计算实提数据, 并更新到数据源上
    getRealData() {
      this.list.forEach(item => {
        if (item.sellerId === 0) {
          item.sellerId = null
        }
        // 临时数据
        let tempTotalRealNum = 0
        let tempTotalRealWeight = 0
        let tempTotalRealPrice = 0
        item.orderItems.forEach(cell => {
          // ~~~~~~~这里有疑问
          // 针对计重商品
          // if (item.statusStr === '待发货' && (cell.weightUnitValue === 'TON' || cell.weightUnitValue === 'KG')) {
          //   // 如果有一个为0, 则这个cell都为0
          //   if (Number(cell.tableData.realNum) === 0 || Number(cell.tableData.realWeight) === 0) {
          //     cell.tableData.realWeight = cell.tableData.realNum  = 0
          //     cell.realProductNum = '0'
          //     cell.realProductWeight = '0.00'
          //   }
          //   // 同时, 修改表格数据源
          //   this.tableList.forEach(temp => {
          //     if (Number(temp.realNum) === 0 || Number(temp.realWeight) === 0) {
          //       temp.realWeight = temp.realNum  = 0
          //     }
          //   })
          // }
          tempTotalRealNum += Number(cell.tableData.realNum)
          tempTotalRealWeight += Number(cell.tableData.realWeight)
          tempTotalRealPrice += Number(cell.tableData.realPrice)
        })
        // 设置数据源实提数据
        item.realProductNum = tempTotalRealNum
        item.realProductWeight = tempTotalRealWeight * 10000 // 这里要传实际的值, 而非展示的值
        item.realProductPrice = tempTotalRealPrice * 100
        // 保存展示用总数量/重量/金额
        this.total.totalRealNum += item.realProductNum
        this.total.totalRealWeight += item.realProductWeight
        this.total.totalRealPrice += item.realProductPrice
      })
    },
    openMsgBox() {
      this.getRealData()
      if (
        this.total.totalRealNum === 0 ||
        this.total.totalRealWeight === 0 ||
        this.total.totalRealPrice === 0
      ) {
        this.$message.error('发货信息不可全部为0, 如不发货，请联系买家取消提货函')
        this.resetTotalData()
        return
      }
      this.$confirm(
        `共 ${this.total.totalRealNum} 件 / ${formatWeight(
          this.total.totalRealWeight
        )} 吨, 合计 ${formatMoneyCent(this.total.totalRealPrice)} 元的商品，是否发货?`,
        '提示',
        {
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          type: 'warning'
        }
      ).then(() => {
        this.submitReal()
      })
      // 清除展示用数据
      this.resetTotalData()
    },
    openNotifyMsgBox() {
      this.$confirm(`确认通知发货？`, `提示`, {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.submitNotify()
      })
    },
    goBackPage() {
      this.$store.commit('tagsView/DEL_VISITED_VIEW', { path: this.$route.path })
      this.$router.replace({ name: 'picker' })
    },
    // 打开合同详情
    toSignDetail({ signStatus, fileKey, dispatchOrderNo }) {
      // const name =  `THH${this.dispatchOrderNo}.${fileKey.split('.').slice(-1)[0]}`
      download(makeImage(fileKey, {}, false))
    },
    // 在线签署
    async goToSign({ contractNo, contractVersion }) {
      if (!contractNo) {
        return this.$message.error('合同尚未生成成功，请刷新后重试')
      }
      let param = {
        contractNo,
        contractVersion,
        source: 2,
        returnUrl: window.location.href,
        expireTime: 604800 // 七天
      }
      let { success, data } = await this.$post('contract.sign', { request: param })
      if (success) {
        window.location.href = data[0].url
      } else {
        switch (data.stat.stateList[0].code) {
          case 5015: // 缺少统一社会信用编码
            this.openVerify(1)
            return false
          case 5014: // 缺法人信息
            this.openVerify(2)
            return false
          case 5017: // 都缺
            this.openVerify()
            return false
          case 5007:
            this.$alert('合同正在生成中，请稍后再试。', '提示', {
              confirmButtonText: '确定',
              callback: () => {
                this.getData()
              }
            })
            return false
          default:
            this.$message.warning('请稍候再试或者联系管理员')
        }
      }
    },
    openVerify(range = 0) {
      this.showRange = range
      this.isShowVerify = true
    },
    async saveReal() {
      // 保存接口
      this.getRealData()
      const { success, data } = await this.$post('lgcenter.updateBatchDispatchOrderForSeller', {
        updateBatchDispatchOrderForSeller: { dispatchOrders: this.list }
      })
      if (success && data[0].success) {
        this.$message.success('实提信息保存成功')
        this.goBackPage()
      } else {
        this.$message.error(data[0].message)
      }
    },
    async submitNotify() {
      const { success, data } = await this.$post('lgcenter.commitDispatchOrderForSellerWarehouse', {
        commitWarehouse: this.list[0]
      })
      if (success && data[0].success) {
        this.$message.success('通知成功')
        this.goBackPage()
      } else {
        this.$message.error(data[0].message || '通知发货失败')
      }
    },
    async submitReal() {
      // 提交接口
      const { success, data } = await this.$post('lgcenter.commitBatchDispatchOrderForSeller', {
        commitBatchDispatchOrderForSeller: { dispatchOrders: this.list }
      })
      if (success && data[0].success) {
        this.$message.success('实提信息提交成功')
        this.goBackPage()
      } else {
        // 发货失败, 展示对应商品的错误信息
        this.$message.error('实提信息有误')
        if (data[0].errors.length > 0) {
          let errorList = []
          data[0].errors.forEach(errorItem => {
            errorItem.data.errorTip = errorItem.error.message
            errorList.push(errorItem.data)
          })
          this.list = errorList
          // 构造实提参数数据
          let tempList = []
          this.list.forEach(item => {
            item.orderItems.forEach(cell => {
              let obj = {}
              obj.dispatchOrderId = cell.dispatchOrderId
              obj.outId = cell.outId
              if (cell.realProductNum === 0) {
                if (
                  cell.valuationWay === '抄码' ||
                  (cell.valuationWay === '理计' && this.PickerStatusStr[item.status] === '待发货')
                ) {
                  obj.realProductNum = cell.preProductNum
                  obj.realProductWeight = cell.preProductWeight
                } else {
                  obj.realProductNum = 0
                  obj.realProductWeight = '0'
                }
              } else {
                obj.realProductNum = cell.realProductNum
                obj.realProductWeight = cell.realProductWeight
              }
              tempList.push(obj)
            })
          })
          // 替换路由参数
          let query = this.$router.history.current.query
          let path = this.$router.history.current.path
          let newQuery = JSON.parse(JSON.stringify(query))
          newQuery.list = encodeURIComponent(JSON.stringify(tempList))
          this.$router.push({ path, query: newQuery })
        }
      }
    },
    async showPickerDialog(item) {
      const { success, data = [] } = await this.$get('lgcenter.queryCertificateList', {
        params: {
          dispatchOrderNo: item.dispatchOrderNo,
          pageSize: 1000
        }
      })
      if (success) {
        const list = (data.pop() || {}).data || []
        list.forEach(item =>
          this.$refs.viewPickerDialog.uploadChange({
            id: item.id,
            fk: item.fileKey,
            name: item.fileName
          })
        )
      }
      this.isShowOption = item.status <= 2
      this.currentUploadItem = item
      this.$refs.viewPickerDialog.visible = true
      this.$refs.viewPickerDialog.setEextraParam(item)
    },
    async saveUploadFiles({ fileList }) {
      const { success } = await this.$get('lgcenter.uploadCertificate', {
        params: {
          dispatchOrderNo: this.currentUploadItem.dispatchOrderNo,
          uploadParamList: fileList
        }
      })
      if (success) {
        this.$message.success('上传成功！')
      }
    }
  }
}
</script>

<style lang="less">
.picker-change {
  .el-table__row {
    height: 125px;
  }
}
.picker-change .el-collapse-item__header {
  height: 100% !important;
  border: 0px !important;
}
.picker-change .el-collapse-item__wrap {
  border: 0px !important;
}
.picker-change .el-collapse-item__arrow {
  display: none !important;
}
.picker-change .el-collapse-item {
  padding: 20px 0 0 0 !important;
}
.picker-change .el-collapse {
  border: 0px !important;
}
// 弹窗
.picker-change .el-dialog__body {
  padding: 20px !important;
}
.picker-change .el-input__inner {
  text-align: center;
}
</style>

<style lang="less" scoped>
.picker-change {
  .tip {
    font-size: 12px;
    position: absolute;
    width: 350px;
    z-index: 999;
    text-align: left;
    left: 10px;
  }
}
</style>
